import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { PageEvent } from '@angular/material/paginator';
import { MatSnackBar } from '@angular/material/snack-bar';
import { BoxService } from 'src/app/service/box.service';
import { ConfirmaDeleteComponent } from 'src/app/util/confirma-delete/confirma-delete.component';
import { Box } from '../box/box';
import { MovimentacaoService } from 'src/app/service/movimentacai.service';
import { Movimentacao } from './movimentacao';

@Component({
  selector: 'app-movimentacao',
  templateUrl: './movimentacao.component.html',
  styleUrls: ['./movimentacao.component.scss']
})
export class MovimentacaoComponent implements OnInit {

  formulario: FormGroup;
  boxsAtivo: Box[] = [];
  ordemColunasTabela = ['id', 'contaOrigemDescricao','contaDestinoDescricao', 'valorMovimentacao','tipoMovimentacao'];
  totalElementos = 0;
  pagina = 0;
  tamanho = 5;
  pageSizeOptions: number[] = [5, 10, 15, 100]; 
  mensagemErros: String[] = []; 
  movimentacoes: Movimentacao[] = [];
  caixaOrigen: any;
  caixaDestino: any;
  tipoFiltro: any;
  parametroConsulta: any;
  tipoFiltros: String[] = ['Periodo'];
  dataInicio: any;
  dataFim: any;

  constructor(private boxService: BoxService,private movimentacaoService: MovimentacaoService,
    private formBilder: FormBuilder,
    private snackBar: MatSnackBar,
    public dialog: MatDialog) { }

  ngOnInit(): void {
    this.iniciarFormulario();
    this.tipoFiltro = "Periodo";
  }

  iniciarFormulario(){
    this.montarFormulario();
    this.listarBoxAtivo();
    this.listarMovimentacoes(this.pagina, this.tamanho);
  }

  submit() {
    const formValues = this.formulario.value;

    const movimentacao: Movimentacao = new Movimentacao(
      formValues.id,
      formValues.observacao,
      formValues.tipoMovimentacao,
      this.caixaOrigen,      
      this.caixaDestino,
      formValues.valorMovimentacao,
      formValues.contaOrigemDescricao, 
      formValues. contaDestinoDescricao);

      this.movimentacaoService.save(movimentacao).subscribe(resposta => {
        this.snackBar.open('Movimentação salvo com sucesso!', 'Sucesso', {
          duration: 2000
        })
        this.formulario.reset();
        this.iniciarFormulario();
      }, errorResponse => {
        this.snackBar.open(errorResponse.error.message, 'ERRO', {
          duration: 2000
        })
      })
  }

  montarFormulario() {
    this.formulario = this.formBilder.group({
      id: [null, Validators.nullValidator],
      observacao: [null, [Validators.minLength(3), Validators.maxLength(250)]],
      tipoMovimentacao: [null, Validators.nullValidator],
      contaOrigem: [null, Validators.nullValidator],
      contaDestino: [null],
      valorMovimentacao: [null, Validators.nullValidator],
      contaOrigemDescricao: [null],
      contaDestinoDescricao: [null]
    }) 
    this.caixaDestino = '';

  }

  limparFormulario() {
    this.formulario.reset();
    this.caixaDestino = null;
    this.caixaOrigen = null;
  }


  private excluir(id: number) {
    this.movimentacaoService.delete(id).subscribe((response) => {
      this.ngOnInit();
      this.mensagemErros = [];
      this.snackBar.open('Movimentação excluido com sucesso!', 'Sucesso', {
        duration: 2000
      })
    }, errorResponse => {
      this.mensagemErros = ['Erro: ' + errorResponse.error.message];
    })
  }
 

  //chamar a paginação
  paginar(event: PageEvent) {
    this.pagina = event.pageIndex;
    this.tamanho = event.pageSize;
    this.consultar();
  }

  openDialog(id: number) {
    const dialogRef = this.dialog.open(ConfirmaDeleteComponent);
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.excluir(id);
      }
    });
  }

  listarBoxAtivo(){
    this.boxService.listarBoxAtivo().subscribe((response) => {
      this.boxsAtivo = response;
    })    
  }

  listarMovimentacoes(pagina: number, tamanho: number) {
    this.movimentacaoService.list(pagina, tamanho).subscribe((response) => {
      this.movimentacoes = response.content; 
      this.totalElementos = response.totalElements;
      this.pagina = response.number;
    });
  }

  consultar(){ 
    this.dataInicio = document.getElementById('dataInicio');
    this.dataFim = document.getElementById('dataFim');    
    this.movimentacaoService.findSale(this.pagina, this.tamanho,this.dataInicio.value,this.dataFim.value).subscribe((response) => {
      this.movimentacoes = response.content; // pegar o conteudo do pag
      this.totalElementos = response.totalElements;// pegar o total de elementos
      this.pagina = response.number;// pegar o numero de paginas
    });
  }

}
